const preloader = () => {
  const preloader = document.getElementById("preloader");
  if (!preloader) return;
  window.scrollTo(0, 0);
  document.querySelector("body").classList.remove("disabled");
  preloader.classList.add("hidden");

  setTimeout(() => {
    preloader.remove();
  }, 1000);
};

export default preloader;

